export default "__VITE_ASSET__BqLs9Qu___"